// Filter inputs fire once per slider tick or keystroke; the count and facets
// requests wait this long for the burst to settle before hitting /api/products.
export const FILTER_REQUEST_DEBOUNCE_MS = 300;

export const FILTER_CATEGORY_TRANSLATION_KEYS = {
	thc: "THC",
	cbd: "CBD",
} as const;

export const FILTER_VALUES_TRANSLATION_KEYS = {
	effects: "filters.effects",
	flavors: "filters.flavors",
	complaints: "filters.complaints",
	terpenes: "filters.terpenes",
	topProducersLowPrice: "filters",
	category: "filters.category",
	priceRanges: "filters.priceRanges",
	thc: "filters.thcRanges",
	cbd: "filters.cbdRanges",
} as const;
